import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { addMoney } from '../../../Payment/promiseAction';
import { parsePrice } from '../../../../utils/utils';
import { sendEvent2, sendToGA } from '../../../../utils/tracking';
import { setMoney } from '../../../Payment/action';
import Input from '../../../UI/InputWithIcon';
import { showLoader } from '../../../Loader/action';

const RechargeForm: FunctionComponent<{
  walletBalance: number;
  updateAction: Function;
}> = ({ walletBalance, updateAction }) => {
  const { register, handleSubmit } = useForm();
  const dispatch = useDispatch();
  const history: any = useHistory();

  const [error, setError] = useState('');

  const dispatchLoader = useCallback((payload: any) => dispatch(showLoader(payload)), [dispatch]);

  const dispatchToStore = useCallback(
    (payload: any) =>
      dispatch(addMoney({ amount: payload.amount })).then((resp: any) => {
        if (resp.data.success) {
          dispatch(setMoney(resp.data));
          localStorage.setItem('referralUrl', window.location.pathname);
          dispatchLoader({ show: false });
          history.push({ pathname: '/portal/payment', state: { fromFastag: true } });
        } else {
          payload.retry++;
          if (payload.retry < 4) {
            dispatchToStore({
              amount: parseFloat(payload.amount),
              retry: payload.retry,
            });
          } else {
            dispatchLoader({ show: false });
            setError('Something went wrong. Please try again.');
          }
        }
      }),
    // TODO: handle dependencies history
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, dispatchLoader],
  );

  const onSubmit = (data?: any) => {
    const { amount } = data;
    let msg = !amount || isNaN(amount) || amount <= 0 ? 'Invalid amount' : '';
    sendEvent2(
      'add_money_btn',
      {
        event_action: 'click',
        event_category: 'we_wallet_txn_pop_up',
        screen_name: 'ft_homescreen',
        miscellaneous: JSON.stringify({
          amount: amount,
        }),
        target_product: 'fastag',
        event_platform: 'web',
      },
      true,
    );
    if (amount > 100000) {
      msg = 'Amount cannot be greater that 100000';
    }

    if (msg) {
      setError(msg);
    } else {
      let retry = 1;
      setError('');
      dispatchLoader({ show: true });
      dispatchToStore({
        amount: parseFloat(amount),
        retry,
      });
      sendToGA('click', 'Add Money', 'Fastag');
    }
  };
  useEffect(() => {
    sendEvent2(
      'pop_up_view',
      {
        event_action: 'view',
        event_category: 'we_wallet_txn_pop_up',
        screen_name: 'ft_homescreen',
        target_product: 'fastag',
        event_platform: 'web',
      },
      true,
    );
  }, []);

  return (
    <div>
      <p className="fwb mb16 pr30">Add Money to Wallet</p>
      <p className="smaller">
        Wallet Balance: <span>{parsePrice({ price: walletBalance })}</span>
      </p>
      <div className="mt24">
        <form className="form-container" onSubmit={handleSubmit(onSubmit)}>
          <p className="small mb8 font-light-grey form-label">Enter Amount</p>
          <div className="flex">
            <Input
              handleChange={() => setError('')}
              register={register}
              type="number"
              placeholder="1000"
              name="amount"
            />
            <input className="form-btn" type="submit" value="Add Money" />
          </div>
          <p className={`form-error ${error ? 'mt8' : 'hide'}`}>{error}</p>
        </form>
      </div>
    </div>
  );
};

export default RechargeForm;
